'use strict';
import module from './bedford-list.module';

module.controller('BedfordListController', [
  'AppService',
  'CurrentUserService',
  function (AppService, CurrentUserService) {
    this.currentUser = CurrentUserService.currentUser;
    AppService.pageTitle = 'Bedford List';
  },
]);
